/**
 * Index.ts
 * @author Abhilash Panwar (abpanwar)
 * @copyright Microsoft 2020
 */
import { isWindowObjectAvailable, getWindow, Utils } from '@microsoft/1ds-core-js';
import { ActionType } from './analytics/Enums';
import Analytics from './Analytics';
export { ActionType, Analytics };
// Run through queue if window object available
if (isWindowObjectAvailable) {
    var win = getWindow();
    var queueName = 'MSEIqueue';
    var queue = win[queueName];
    if (Utils.isArray(queue)) {
        for (var index = 0; index < queue.length; index++) {
            var args = queue[index];
            if (args[0] === 'new') {
                win[args[1]] = new Analytics();
            }
            else {
                win[args[1]][args[0]].apply(win[args[1]], args[2]);
            }
        }
    }
    delete win[queueName];
}
//# sourceMappingURL=Index.js.map